import {filter} from 'lodash';

import {PieChartMetricConfig} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {UsersAvailabilityData} from 'types';

export enum UsersAvailabilityMetric {
    Online = 'online',
    Offline = 'offline',
    Away = 'away',
    InSession = 'in-session',
    NotInSession = 'not-in-session'
}

type UsersAvailabilityConfig = PieChartMetricConfig<UsersAvailabilityMetric, UsersAvailabilityData>;

export const UsersAvailabilityMetricConfig: Record<UsersAvailabilityMetric, UsersAvailabilityConfig> = {
    [UsersAvailabilityMetric.Online]: {
        metric: UsersAvailabilityMetric.Online,
        color: '#6FCF97',
        ratioColor: '',
        title: TRANSLATION_KEYS.COMPONENTS.ONLINE_STATE.ONLINE,
        valueGetter: (data) => filter(data.users,
            (user) => data.onsiteUsersEids.includes(user.eid) && user.isAvailable).length,
        totalGetter: (data) => data.users.length
    },
    [UsersAvailabilityMetric.Offline]: {
        metric: UsersAvailabilityMetric.Offline,
        color: '#EB5757',
        ratioColor: '',
        title: TRANSLATION_KEYS.COMPONENTS.ONLINE_STATE.OFFLINE,
        valueGetter: (data) => data.users.length - data.onsiteUsersEids.length,
        totalGetter: (data) => data.users.length
    },
    [UsersAvailabilityMetric.Away]: {
        metric: UsersAvailabilityMetric.Away,
        color: '#e0e0e0',
        ratioColor: '',
        title: TRANSLATION_KEYS.COMPONENTS.ONLINE_STATE.AWAY,
        valueGetter: (data) => filter(data.users,
            (user) => data.onsiteUsersEids.includes(user.eid) && !user.isAvailable).length,
        totalGetter: (data) => data.users.length
    },
    [UsersAvailabilityMetric.InSession]: {
        metric: UsersAvailabilityMetric.InSession,
        color: '#6FCF97',
        ratioColor: '',
        title: TRANSLATION_KEYS.COMMON.ALL.IN_SESSION,
        valueGetter: (data) => filter(data.users,
            (user) => user.isAvailable && data.onsiteUsersEids.includes(user.eid) && data.inSessionUsersEids.includes(user.eid)
        ).length,
        totalGetter: (data) => filter(data.users,
            (user) => user.isAvailable && data.onsiteUsersEids.includes(user.eid)
        ).length,
    },
    [UsersAvailabilityMetric.NotInSession]: {
        metric: UsersAvailabilityMetric.NotInSession,
        color: '#e0e0e0',
        ratioColor: '',
        title: TRANSLATION_KEYS.COMMON.ALL.NOT_IN_SESSION,
        valueGetter: (data) => filter(data.users,
            (user) => user.isAvailable && data.onsiteUsersEids.includes(user.eid) && !data.inSessionUsersEids.includes(user.eid)
        ).length,
        totalGetter: (data) => filter(data.users,
            (user) => user.isAvailable && data.onsiteUsersEids.includes(user.eid)
        ).length,
    },
};
